import { isMobile, screenCategory } from 'lib/utils';
let carousel = require('lib/carousel');
require('jquery-smooth-scroll');

carousel($('.litigation-results'), {
    pageSize: screenCategory() <= 2 ? 1 : 3,
    filter: screenCategory() === 1 && '.mobile'
});


$('a.case-review-scroll').smoothScroll({
    scrollTarget: '.case-evaluation-form-container'
});


// WEBPACK FOOTER //
// ./assets/js/app/pages/home.js